import React from 'react';
import useReveal from '../hooks/useReveal';
import './PitchDeck.css';
import { trackEvent } from '../analytics';

export default function PitchDeck() {
  const ref = useReveal();
  return (
    <section className="section pitchdeck" id="pitch-deck">
      <div className="container reveal" ref={ref}>
        <div className="pitchdeck__card">
          <div className="pitchdeck__copy">
            <p className="eyebrow eyebrow--light">For investors</p>
            <h2>The full Inivayal pitch deck.</h2>
            <p className="pitchdeck__desc">
              Problem, solution, market sizing, product, business model, traction and team —
              everything in one deck.
            </p>
            <div className="pitchdeck__actions">
              <a
                href="/Inivayal-Pitch-Deck.pptx"
                className="btn btn-yellow"
                onClick={() => trackEvent('pitch_deck_open', { file: 'Inivayal-Pitch-Deck.pptx' })}
              >
                Open Pitch Deck (.pptx)
              </a>
              <a
                href="/Inivayal-Pitch-Deck.pptx"
                download
                className="btn btn-ghost"
                onClick={() => trackEvent('pitch_deck_download', { file: 'Inivayal-Pitch-Deck.pptx' })}
              >
                Download
              </a>
            </div>
            <p className="pitchdeck__note">
              Opens in a new tab if your browser / OS has PowerPoint or a compatible viewer set as
              default for .pptx files — otherwise it downloads directly.
            </p>
          </div>

          <div className="pitchdeck__preview" aria-hidden="true">
            <img src="/assets/images/pitch-poster.jpg" alt="" loading="lazy" />
            <div className="pitchdeck__preview-badge">10 slides</div>
          </div>
        </div>
      </div>
    </section>
  );
}
